export interface DotKiemKe_ThanhVien {
    id?: number;
    idDotKiemKe?: number;
    idNhanVien?: number;
    hoTen: string;
    tenChucVu?: string;
    vaiTro: string;
    thuTu?: number;
}

export interface DotKiemKeTaiSan {
    id?: number;
    maDotKiemKe: string;
    tenDotKiemKe: string;
    ngayBatDau: Date;
    ngayKetThuc: Date;
    trangThai: number;
    moTa?: string;
    idNguoiPhuTrach?: number;
    idsDSNguoiPhuTrach?: number[];
    nguoiPhuTrach?: string;
    dSNguoiPhuTrach?: string;
    tinhTrang?: number;
    idNVKhoiTao?: number;
    tenNVKhoiTao?: string;
    soLuongTaiSan?: number;
    soLuongDaKiem?: number;
    idPhoCVP?: number;
    tenPhoCVP?: string;
    idPhoGiamDoc?: number;
    tenPhoGiamDoc?: string;
    idChanhVP?: number;
    tenChanhVP?: string;
    idGiamDoc?: number;
    tenGiamDoc?: string;
    fileDinhKemToKiemKe?: string;
    dsThanhVien?: DotKiemKe_ThanhVien[];
}

export interface DotKiemKeTaiSanRequest {
    id?: number;
    maDotKiemKe: string;
    tenDotKiemKe: string;
    ngayBatDau: string;
    ngayKetThuc: string;
    trangThai: number;
    moTa?: string;
    idsDSNguoiPhuTrach?: number[];
    idPhoCVP?: number;
    idPhoGiamDoc?: number;
    idChanhVP?: number;
    idGiamDoc?: number;
    jsonDsThanhVien?: string;
    dsThanhVien?: DotKiemKe_ThanhVien[];
}

export interface TimKiemDotKiemKeTaiSanRequest {
    tuKhoa?: string;
    trangThai?: number;
    tuNgay?: Date;
    denNgay?: Date;
}

// Trạng thái đợt kiểm kê
export enum TrangThaiDotKiemKe {
    KhoiTao = 0,
    ThuHoi = 1,
    TrinhPhoCVP = 2,
    PhoCVPTraLai = 3,
    TrinhCVP = 4,
    CVPTraLai = 5,
    TrinhPhoGiamDoc = 6,
    PhoGiamDocTraLai = 7,
    TrinhGiamDoc = 8,
    GiamDocTraLai = 9,
    PheDuyet = 10,
    DangKiemKe = 11,
    HoanThanh = 12,
    DaDong = 13
}
